import Jedi from "./jedi/jedi";
import Meniji from "./meniji/meniji";
import Preference from "./preference/preference";
import Profil from "./Profil/Profil";
import Admin from "./Admin/admin";
import Kalibracija from "./kalibracija/kalibracija";
import "../style.css";
import "./user-area.css";
import React, { useState } from "react";
import {
	BrowserRouter as Router,
	Route,
	NavLink,
	Routes,
	Navigate,
} from "react-router-dom";
import { API_URL } from "../../api";
import Cookies from "universal-cookie";

const UserPage = ({ data }) => {
	const [isMobile] = useState(window.innerWidth < 500);
	const [username] = useState(data.username);
	const [sessionToken] = useState(data.sessionToken);

	const Logout = async () => {
		try {
			const response = await fetch(
				`${API_URL}/api/ChangeToken?token=${encodeURIComponent(
					sessionToken
				)}`
			);
			const data = await response.json();
			console.log(data);
		} catch (error) {
			console.log(error);
		}
		const cookies = new Cookies();
		cookies.set("sessionToken", "logout", { path: "/" });
		window.location.href = "/";
	};

	return (
		<Router>
			<div>
				<nav id="navbar">
					<ul>
						<li className="leftNavbar">
							<NavLink to="/profil">
								{isMobile ? (
									<a href="#profil">
										<span class="material-symbols-outlined circle">
											account_circle
										</span>
									</a>
								) : (
									<a href="#profil">
										<span className="material-symbols-outlined circle">
											account_circle
										</span>
										{username}
									</a>
								)}
							</NavLink>
						</li>
						<li>
							<NavLink
								className="nav-link mobileNav"
								to="/jedi"
								onClick={() => {
									setTimeout(() => {
										window.location.reload();
									}, 1);
								}}>
								{isMobile ? (
									<>
										<span class="material-symbols-outlined mobileNav">
											lunch_dining
										</span>
									</>
								) : (
									"Jedi"
								)}
							</NavLink>
						</li>
						<li>
							<NavLink className="nav-link" to="/meniji">
								{isMobile ? (
									<>
										<span class="material-symbols-outlined mobileNav">
											menu_open
										</span>
									</>
								) : (
									"Meniji"
								)}
							</NavLink>
						</li>
						<li>
							<NavLink to="/nastavitve">
								{isMobile ? (
									<>
										<span class="material-symbols-outlined mobileNav">
											settings
										</span>
									</>
								) : (
									"Nastavitve"
								)}
							</NavLink>
						</li>
						<li onClick={Logout}>
							<span
								style={{ paddingTop: "0.25em" }}
								className="navIcons material-symbols-outlined nav-link mobileNav">
								logout
							</span>
						</li>
					</ul>
				</nav>
				<div className="options">
					<Routes>
						<Route path="/admin" element={<Admin data={data} />} />
						<Route
							path="/"
							element={<Navigate to="/nastavitve" />}
						/>
						<Route path="/jedi" element={<Jedi data={data} />} />
						<Route
							path="/meniji"
							element={<Meniji data={data} />}
						/>
						<Route
							path="/nastavitve"
							element={<Preference data={data} />}
						/>
						<Route
							path="/profil"
							element={<Profil data={data} />}
						/>
						<Route
							path="/kalibracija"
							element={<Kalibracija data={data} />}
						/>
					</Routes>
				</div>
			</div>
		</Router>
	);
};

export default UserPage;
